module.exports = __webpack_public_path__ + "img/email.0288aa07.png";